import {
  ChangeDetectorRef,
  Component,
  EventEmitter, HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { CommonService } from "@services/common.service";
import { FundListingBRConfiguration, FundListingDataFormat } from "@types";
import { Location } from "@angular/common";
import { Subscription } from "rxjs";

@Component({
  selector: "ft-watch-list-content",
  templateUrl: "./watch-list-content.component.html",
  styleUrls: ["./watch-list-content.component.scss"],
})
export class WatchListContentComponent implements OnChanges, OnInit, OnDestroy {
  @Input() isAddFund = false;
  @Input() showWatchlist: boolean | undefined;
  @Input() sideFilterOptions: any;
  @Input() fund: any;
  @Input() watchListingData: any;
  @Input() fundCompareIds: any;
  @Input() fundData: any;
  @Input() cardTypeData: any;
  @Output() toggleDataCard: EventEmitter<boolean> = new EventEmitter<boolean>();
  Data: any = [];
  fundListingData: FundListingDataFormat[] | FundListingDataFormat[];
  @Input() brConfiguration: FundListingBRConfiguration;
  funds: any = [];
  fullFundsArray: any = [];
  recentSearchFunds: any = [];
  recentSearchLocalstorageFundNames: any = [];
  isRecentSearchAddButton: boolean = false;
  isLoaded: boolean;
  badgeValue: string;
  filterName: string;
  focusFunds: any = [];
  getAddFund: boolean;
  categoryOptions: any = [];

  isMobileView: boolean;
  isMobileAddClicked: boolean = false;
  watchListFull: boolean = false;
  updateWatchListSubscription: Subscription;
  isAddFundsDisabled: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
    private location: Location
  ) {
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize($event: any = {}) {
    this.isMobileView = window.innerWidth < 900;
  }

  ngOnInit(): void {
    this.isMobileView = window.innerWidth < 900;
    this.getRecentSearchFunds();

    this.commonService.is_watchList_fund_added.subscribe((getFund) => {
      if (getFund) {
        this.customizeFundData()
        this.getCategoryList("watch-list-tab");
      }
    });
    this.commonService.mobileAddFund.subscribe((status) => {
      if (status) {
        this.isMobileAddClicked = false;
        window.scrollTo(0, 0);
      }
    })
    this.updateWatchListSubscription = this.commonService.updateWatchList.subscribe((update) => {
      if (update) {
        this.getCategoryList("watch-list-tab");
      }
    });
  }

  ngOnChanges() {
    if (this.fundData || this.watchListingData) {
      this.customizeFundData();
      this.isLoaded = true;
      this.getCategoryList("watch-list-tab");
    }
  }

  getRecentSearchFunds() {
    this.recentSearchFunds = [];
    this.recentSearchLocalstorageFundNames =
      JSON.parse(localStorage.getItem("recent-search")) || [];
    this.recentSearchFunds = this.recentSearchLocalstorageFundNames?.map(
      (recentSearchItem) =>
        this.fundData.find(
          (fund) => fund.fundName === recentSearchItem.fundName
        )
    );
  }

  customizeFundData() {
    let modifiedData = this.fundData.filter((fund) =>
      this.watchListingData.some(
        (watchListItem) => fund.fundId === watchListItem.fundId
      )
    );
    // Sort the array based on averageAnnualReturnSinceInception
    modifiedData.sort((a, b) => {
      const returnA = parseFloat(
        a?.shareClassData?.performanceData?.averageAnnualReturnSinceInception
      );
      const returnB = parseFloat(
        b?.shareClassData?.performanceData?.averageAnnualReturnSinceInception
      );

      // Check if the parsed values are valid numbers
      const isValidNumberA = !isNaN(returnA);
      const isValidNumberB = !isNaN(returnB);

      // Handle cases where either or both values are not valid numbers
      if (isValidNumberA && isValidNumberB) {
        // Sort based on valid numeric values
        return returnB - returnA;
      } else if (isValidNumberA && !isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return -1;
      } else if (!isValidNumberA && isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return 1;
      } else {
        // Maintain the current order if neither value is a valid number
        return 0;
      }
    });
    for (let i = 0; i < modifiedData.length; i++) {
      let selectedFund = modifiedData[i];

      // Find the object with value "averageAnnualReturnSinceInception" in ppssPeriodDropdownItems
      let selectedDropdown = selectedFund.ppssPeriodDropdownItems.find(
        (item) => item.value === "averageAnnualReturnSinceInception"
      );

      // Add selectedDropdown to the main object
      selectedFund.selectedDropdown = selectedDropdown;
    }
    // Adding the Focus Badge.
    this.fundListingData = modifiedData.map((fund) => {
      // Check if the fundId is in focusFunds array
      if (
        this.focusFunds.some((focusFund) => focusFund.fundId === fund.fundId)
      ) {
        // Add the badge property
        return {
          ...fund,
          badge: this.badgeValue ? this.badgeValue : "focus",
          addBtnStatus: true,
        };
      }
      return fund;
    });

    // Sort the array based on badge and prioritize funds with badge: focus
    this.fundListingData.sort((a, b) => {
      // Check if funds have the badge: focus property
      const aHasFocusBadge = a.badge === "focus";
      const bHasFocusBadge = b.badge === "focus";

      // Prioritize funds with the badge: focus property
      if (aHasFocusBadge && !bHasFocusBadge) {
        return -1;
      } else if (!aHasFocusBadge && bHasFocusBadge) {
        return 1;
      }

      // If both funds have the badge: focus property or neither does,
      // maintain the current order in the array
      return 0;
    });
    this.fullFundsArray = this.fundListingData;
  }

  showContentOnHover(event: any) {
    //console.log("target", event.target.id);
    if (event.target.id) {
      // debugger
      document.getElementById(event.target.id)?.click();
      this.fundListingData = [];
      this.recentSearchFunds = [];
      this.customizeFundData();
      this.getRecentSearchFunds();
      if (event.target.id !== "All") {
        this.fundListingData = this.fundListingData.filter(
          (fund) => fund.assetClass === event.target.id
        );
        this.recentSearchFunds = this.recentSearchFunds.filter(
          (fund) => fund.assetClass === event.target.id
        );

        // console.log(this.recentSearchFunds, "ifhover");
      }
      this.cdr.detectChanges();
    }
  }

  addFundsButtonClick() {
    this.getAddFund = true;
    const getToggle: boolean = false;
    sessionStorage.setItem("getToggle", JSON.stringify(getToggle));
    this.isMobileView = window.innerWidth < 900;
    if (this.isMobileView) {
      this.isMobileAddClicked = true;
      this.commonService.send_added_fund.emit(true);
    }
    this.cdr.detectChanges();
  }

  getCategoryList(tab: any) {
    if (tab === 'recent-searches-tab') {
      this.isAddFundsDisabled = true;
    } else {
      this.isAddFundsDisabled = false;
    }
    this.customizeFundData();
    this.getRecentSearchFunds();
    document.getElementById("All")?.click();
    if (this.sideFilterOptions) {
      let watchListCategoryOptions = this.sideFilterOptions.filter((option) =>
        this.watchListingData.some(
          (watchListItem) =>
            option.name === watchListItem.assetClass || option.name === "All"
        )
      );
      let recentSearchCategoryOptions = this.sideFilterOptions.filter((option) =>
        this.recentSearchFunds?.some(
          (recentSearchItem) =>
            option.name === "All" || option.name === recentSearchItem.assetClass
        )
      );
      this.categoryOptions =
        tab == "watch-list-tab"
          ? watchListCategoryOptions
          : recentSearchCategoryOptions.length
            ? recentSearchCategoryOptions
            : watchListCategoryOptions;
    }

    this.isRecentSearchAddButton = (
      tab === "watch-list-tab" || this.recentSearchFunds.length > 0) ? true : false;

  }

  backClicked() {
    this.location.back();
  }

  closeWatchListFull() {
    this.watchListFull = !this.watchListFull;
  }

  mobileAddFundGoBack() {
    if (window.innerWidth < 900) {
      this.commonService.mobileAddFund.emit(true);
    }
  }

  ngOnDestroy(): void {
    if (this.updateWatchListSubscription) {
      this.updateWatchListSubscription.unsubscribe();
    }
  }

}
